import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import '../styles/Header.css';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = () => {
    setExpanded(false);
  };

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/' ? 'active' : '';
    return location.pathname.startsWith(path) ? 'active' : '';
  };

  return (
    <header className={`app-header ${scrolled ? 'scrolled' : ''}`}>
      <Container>
        <Navbar expand="lg" expanded={expanded} onToggle={setExpanded}>
          <Navbar.Brand as={Link} to="/" onClick={handleNavClick}>
            <img
              src="/img/logo-agricampanha.png"
              alt="Agricampanha Logo"
              className="navbar-brand-logo"
              loading="eager"
            />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="navbar-nav"
            aria-label="Toggle navigation"
          >
            {expanded
              ? <i className="bi bi-x" style={{ fontSize: '1.6rem', color: 'var(--color-primary-dark)' }}></i>
              : <i className="bi bi-list" style={{ fontSize: '1.6rem', color: 'var(--color-primary-dark)' }}></i>
            }
          </Navbar.Toggle>

          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link
                as={Link}
                to="/"
                onClick={handleNavClick}
                className={isActive('/')}
              >
                Início
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/quem-somos"
                onClick={handleNavClick}
                className={isActive('/quem-somos')}
              >
                Quem Somos
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/noticias"
                onClick={handleNavClick}
                className={isActive('/noticias')}
              >
                Notícias
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/dia-de-campo"
                onClick={handleNavClick}
                className={isActive('/dia-de-campo')}
              >
                Dia de Campo
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/projetos"
                onClick={handleNavClick}
                className={isActive('/projetos')}
              >
                Projetos
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/#contato"
                onClick={handleNavClick}
              >
                Contato
              </Nav.Link>
            </Nav>

            <div className="header-cta">
              <Button
                variant="primary"
                onClick={() => {
                  handleNavClick();
                  navigate('/#contato');
                }}
              >
                Seja Associado
              </Button>
            </div>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </header>
  );
};

export default Header;
